routing.$inject = ['$locationProvider', '$urlRouterProvider', '$stateProvider']

export default function routing($locationProvider, $urlRouterProvider, $stateProvider) {
  $locationProvider.html5Mode(true)
  $urlRouterProvider.otherwise('/session')

  $stateProvider
    .state('shell', {
      abstract: true,
      template: require('./shell.html'),
      controller: 'ShellController',
      controllerAs: 'shell'
    })
}